<template>
    <panel v-if="claims.upcomingEvent.read"
        :panel="this.panel" />
</template>

<script>
    import Panel from '../Panel';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            panel: Object
        },
        components: {
            Panel
        },
        computed: {
            ...mapGetters(['claims'])
        }
    }
</script>

